export default {
    signin: 'api/auth/signin',
    logout: 'api/auth/logout',
    dashboard: {
        get: 'api/analytics/dashboard'
    },
    analytics: {
        get: 'api/analytics/',
        whitelisted: '/api/analytics/whitelisted_ctas_counts',
        shortened: '/api/analytics/total_url_shortened',
        clicks: '/api/analytics/clicks_counts',
        clicksTrend: '/api/analytics/clicks_trend',
        links: '/api/analytics/links_counts',
        typeClicks: '/api/analytics/type_wise_counts'
    },
    cta: {
        set: 'api/cta/createedit',
        get: 'api/cta/get_list',
        downloadAll: 'api/cta/download_all',
        detail: 'api/cta/detail',
        bulkUpload: 'api/cta/bulk/upload',
        bulkGet: 'api/cta/bulk/get',
        bulkFileDownload: 'api/cta/bulk/download-file',
        identifiers: 'api/cta/identifiers'
    },
    link: {
        set: 'api/link/createedit',
        get: 'api/link/get_list',
        detail: 'api/link/detail',
        bulkUpload: 'api/link/bulk/upload',
        bulkGet: 'api/link/bulk/get',
        downloadFile: 'api/link/download-file'
    },
    subscription: {
        check: 'api/subscription/is_enabled'
    },
    domain: {
        set: 'api/custom_domain/createedit',
        get: 'api/custom_domain/get_list',
        detail: 'api/custom_domain/detail',
        upload: 'api/custom_domain/upload',
        getActive: 'api/custom_domain/get_verified_domains'
    },
    domains: {
        set: '/api/domains/createedit',
        get: '/api/domains/get_list'
    },
    webhook: {
        set: 'api/webhook/createedit',
        get: 'api/webhook/get_config'
    },
    setting: {
        user: {
            get: 'api/setting/get_users'
        },
        default: {
            get: 'api/setting/get_setting',
            set: 'api/setting/update'
        }
    }
}
